module.exports = window["nab"]["i18n"];